/**
 * cod-form.js — EasySell COD
 * Rôle : timer 24h + quantité + validation front + soumission native
 * La création de commande et la page de confirmation sont gérées
 * entièrement par EasySell COD (proxy Shopify natif).
 */
(function () {
  'use strict';

  /* ══════════════════════════════════════════════
     1. COMPTEUR 24H EN BOUCLE INFINIE
  ══════════════════════════════════════════════ */
  function initCODTimer() {
    var displays = document.querySelectorAll('.cod-timer-display');
    if (!displays.length) return;

    var STORAGE_KEY  = 'cod_timer_end';
    var DURATION_MS  = 24 * 60 * 60 * 1000; // 24 h

    function getEndTime() {
      var stored = localStorage.getItem(STORAGE_KEY);
      var now    = Date.now();
      if (stored) {
        var end = parseInt(stored, 10);
        if (end > now) return end;           // cycle en cours
      }
      var newEnd = now + DURATION_MS;        // nouveau cycle
      localStorage.setItem(STORAGE_KEY, newEnd);
      return newEnd;
    }

    var endTime = getEndTime();
    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function tick() {
      var remaining = endTime - Date.now();
      if (remaining <= 0) {
        endTime = Date.now() + DURATION_MS;  // redémarre infiniment
        localStorage.setItem(STORAGE_KEY, endTime);
        remaining = DURATION_MS;
      }
      var h   = Math.floor(remaining / 3600000);
      var m   = Math.floor((remaining % 3600000) / 60000);
      var s   = Math.floor((remaining % 60000)  / 1000);
      var txt = pad(h) + ':' + pad(m) + ':' + pad(s);
      displays.forEach(function (d) { d.textContent = txt; });
    }

    tick();
    setInterval(tick, 1000);
  }

  /* ══════════════════════════════════════════════
     2. BOUTONS +/- QUANTITÉ
  ══════════════════════════════════════════════ */
  function initQtyControls() {
    document.querySelectorAll('.cod-qty-minus').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = document.getElementById(btn.dataset.target);
        var val   = parseInt(input.value, 10) || 1;
        if (val > 1) {
          input.value = val - 1;
          input.dispatchEvent(new Event('change'));
        }
      });
    });
    document.querySelectorAll('.cod-qty-plus').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = document.getElementById(btn.dataset.target);
        var val   = parseInt(input.value, 10) || 1;
        input.value = val + 1;
        input.dispatchEvent(new Event('change'));
      });
    });
  }

  /* ══════════════════════════════════════════════
     3. TOTAL DYNAMIQUE
  ══════════════════════════════════════════════ */
  function initPriceUpdate() {
    document.querySelectorAll('.cod-qty-input').forEach(function (input) {
      input.addEventListener('change', function () {
        var form      = input.closest('.cod-form');
        if (!form) return;
        var unitPrice = parseFloat(form.dataset.unitPrice) || 0;
        var qty       = parseInt(input.value, 10) || 1;
        var totalEl   = form.querySelector('.cod-price-total');
        var currency  = form.dataset.currency || '';
        if (totalEl) totalEl.textContent = (unitPrice * qty).toFixed(2) + ' ' + currency;
      });
    });
  }

  /* ══════════════════════════════════════════════
     4. VALIDATION FRONT
  ══════════════════════════════════════════════ */
  function validateForm(form) {
    var valid = true;
    form.querySelectorAll('[data-cod-required]').forEach(function (field) {
      var val = field.value.trim();
      field.classList.remove('cod-error');
      if (!val) {
        field.classList.add('cod-error');
        valid = false;
        return;
      }
      if (field.dataset.codRequired === 'phone') {
        if (val.replace(/\D/g, '').length < 8) {
          field.classList.add('cod-error');
          valid = false;
        }
      }
    });
    return valid;
  }

  /* ══════════════════════════════════════════════
     5. SOUMISSION — laisse EasySell faire son travail
     Le formulaire POST nativement vers /apps/easysell-cod.
     EasySell crée la commande Shopify → Shopify notifie
     le propriétaire → EasySell redirige vers sa page de
     confirmation (ou la page order_status de Shopify).
  ══════════════════════════════════════════════ */
  function initCODForm() {
    document.querySelectorAll('.cod-form').forEach(function (form) {

      // Efface l'erreur dès que l'utilisateur retape
      form.addEventListener('input', function (e) {
        if (e.target.dataset.codRequired) {
          e.target.classList.remove('cod-error');
        }
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault(); // on valide d'abord

        if (!validateForm(form)) {
          var first = form.querySelector('.cod-error');
          if (first) first.focus();
          return;
        }

        // Passage en état "chargement"
        var btn = form.querySelector('.cod-submit-btn');
        btn.disabled = true;
        btn.classList.add('loading');

        // Soumission native — EasySell prend le relais
        form.submit();
      });
    });
  }

  /* ══════════════════════════════════════════════
     BOOT
  ══════════════════════════════════════════════ */
  function boot() {
    initCODTimer();
    initQtyControls();
    initPriceUpdate();
    initCODForm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
